import React, { useEffect, useMemo } from "react";
import "./style.less";
import { verifyemail } from "@/util/http/auth/auth.index";
import { useNavigate } from "react-router-dom";

const VerifyEmail: React.FC = () => {
  const navigate = useNavigate();
  const token = useMemo(() => {
    // HashRouter URLs keep query params after '#', e.g. /#/verifyemail?token=...
    const hash = window.location.hash || "";
    const hashQuery = hash.includes("?") ? hash.slice(hash.indexOf("?")) : "";
    const hashToken = new URLSearchParams(hashQuery).get("token");

    if (hashToken) return hashToken;

    // Fallback for non-hash routes: /verifyemail?token=...
    const searchToken = new URLSearchParams(window.location.search).get("token");
    return searchToken || "";
  }, []);

  const verifyemailFunc = async(token: string)=>{
    // Call the API to verify the email
    try {
      const response = await verifyemail({
        token: token
      });
      if(response?.status === 200 && response?.data ){
        const nameArray = response.data.split("/");
        navigate(`/auth/register/activate-account/${nameArray[0]}/${nameArray[1]}`);
      }
      console.log("Email verification response:", response);
    } catch (error) {
      console.error("Error verifying email:", error);
    }
  };

  useEffect(() => {
    if (token) {
      console.log("Token found:", token);
      verifyemailFunc(token);
    }
  }, [token]);

  // const handleVerifyEmail = () => {
  //   if (!token) return;

  //   const verifyUrl = `https://dev.kartoffelprognose.de/api/User/verifyemail?token=${encodeURIComponent(
  //     token
  //   )}`;

  //   window.open(verifyUrl, "_blank", "noopener,noreferrer");
  // };
  //   console.log("Token:", token);

  return (
    <div className="verify-email">
      {/* <button onClick={handleVerifyEmail} disabled={!token}>
        E-MAIL-ADRESSE BESTÄTIGEN
      </button> */}
    </div>
  );
};

export default VerifyEmail;